import React from 'react';

const principles = [
  {
    title: 'Specificity',
    copy:
      'No matter what race you’re training for, the key workouts are always going to be very near your goal race pace.',
  },
  {
    title: 'Minimum Effective Dose',
    copy:
      'We prioritize consistency over always pushing the envelope. Hard workouts are crucial, but we save them until late in the training cycle, when medium workouts are no longer stimulating adaptations.',
  },
  {
    title: 'Community',
    copy:
      'We’re faster running together. Your teammates help you dig deeper in a tough workout. They make it easier to get out the door on a rainy winter morning. They tell you when you’re being stubborn and need to rest to avoid an injury.',
  },
  {
    title: 'Love of the Game',
    copy:
      'We take our running seriously, but we aren’t paying rent with our race winnings. We do it because it’s fun, and if we lose sight of that, it’s just not worth the effort.',
  },
  {
    title: 'Repping the District',
    copy:
      'We celebrate our training at races across the country. Every race is a chance to represent our club and our city with pride.',
  },
];



const weeklySchedule = [
  {
    day: 'Tuesday',
    title: 'Speed Work',
    description: 'Example workout: 20×400m @ 5K effort starting every two minutes (plus warmup and cooldown).',
    location: '@ Hains Point',
  },
  {
    day: 'Thursday',
    title: 'Aerobic Work',
    description: 'Example workout: 5 miles aerobic plus 4–6 × 20-second strides for turnover.',
    location: '@ Hains Point',
  },
  {
    day: 'Saturday',
    title: 'Long Run',
    description: 'Example workout: 12–20 miles with 2–3 × 5-mile marathon-pace blocks.',
    location: '@ Baked & Wired',
  },
];

const seasonalCalendar = [
  {
    season: 'Fall',
    title: 'Marathon Build',
    notes: 'Progressive long runs, tempo blocks, and marathon-specific training.',
  },
  {
    season: 'Winter',
    title: 'Down Season / Strength',
    notes: 'Shorter aerobic work, indoor track racing, and prep for the spring race season',
  },
  {
    season: 'Spring',
    title: 'Cherry Blossom / Boston',
    notes: 'Race simulations on Hains Point, Boston-specific long runs, and sharpening workouts for goal races.',
  },
  {
    season: 'Summer',
    title: 'Track / Speed Work / Hood to Coast',
    notes: 'Evening track meets, relay prep, and outdoor track sessions.',
  },
];


export default function TrainingPhilosophy() {
  return (
    <section className="page philosophy-page">
      <header className="section-header centered serif">
        <h1 className='title'>Training Philosophy</h1>
        <p>
        Dojo’s philosophy is that the training that works for the best runners in the world also works for mere mortals — even people who didn’t run in college. Obviously, our paces will be (a lot) slower, and we may not be able to handle quite the same volume, but in broad strokes, there are no major differences between what we do and what the pros do. These are the basic principles of our training:
</p>

      </header>

      <section className="principles-section">
        <div className="principles-stack">
          {principles.map(({ title, copy }, index) => (
            <article key={title} className="principle-row">
              <span className="principle-row__index">{String(index + 1)}</span>
              <div>
                <h3 className="principle-row__title"><i>{title}</i></h3>
                <p>{copy}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="schedule-section">
      <header  className="section-header centered serif">
      <h1 >Sample week</h1>
        </header>
        <div className="schedule-stack">
        {weeklySchedule.map(({ day, title, description, time, location, duration }) => (
          <article key={day} className="schedule-card">
            <div className="schedule-card__heading">
              <div>
                <p className="schedule-card__day">{day}</p>
                <h2>{title}</h2>
                <i>{description}</i>
              </div>
              <p className="schedule-card__time">{time}</p>
            </div>
            <div className="schedule-card__meta">
              <span>{location}</span>
              <span>{duration}</span>
            </div>
          </article>
        ))}
        </div>
      </section>

      <section className="seasonal-calendar">
        <header className="section-header centered serif">
        <h1 className='title'>Annual Calendar</h1>

        </header>
        <div className="season-grid">
          {seasonalCalendar.map(({ season, title, notes }) => (
            <article key={season} className="season-card">
              <p className="season-card__label">{season}</p>
              <h3>{title}</h3>
              <p>{notes}</p>
            </article>
          ))}
        </div>
      </section>
    </section>
  );
}
